import Adicionar from './Adicionar';
import Editar from './Editar';
import Lista from './Lista';

export const DicaMaisAdicionar = Adicionar;
export const DicaMaisEditar = Editar;
export const DicaMaisLista = Lista;
